const { components } = require("./components/index");
const { events } = require("./events/index");

const PremiumScheduleSection = {
  events,
  components
};

export { PremiumScheduleSection };